import { client } from "./index";

// Orders of one website (/api/admin/sites/:siteId/orders), including the CSV export
export const getOrders = (siteId, params) => client.get(`/admin/sites/${siteId}/orders`, { params });
export const getOrderById = (siteId, orderId) => client.get(`/admin/sites/${siteId}/orders/${orderId}`);
export const updateOrder = (siteId, orderId, payload) => client.put(`/admin/sites/${siteId}/orders/${orderId}`, payload);
export const addDemoOrders = (siteId, count = 50) => client.post(`/admin/sites/${siteId}/orders/demo`, { count });

// Downloads the CSV for the orders matching the current filters
// Downloads a file the API sends back (CSV or Excel)
export function saveDownload(data, filename, type) {
  const url = window.URL.createObjectURL(new Blob([data], { type }));
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

const EXCEL = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

// format: "csv" (default) or "xlsx"
export async function exportOrdersCsv(siteId, params, format = "csv") {
  const response = await client.get(`/admin/sites/${siteId}/orders/export`, { params: { ...params, format }, responseType: "blob" });
  saveDownload(response.data, `${siteId}-orders.${format}`, format === "xlsx" ? EXCEL : "text/csv;charset=utf-8;");
}

// Courier (Shiprocket, the store owner's own account): rates, booking and tracking for one order
export const getCourierRates = (siteId, orderId, params) => client.get(`/admin/sites/${siteId}/orders/${orderId}/courier-rates`, { params });
export const shipOrder = (siteId, orderId, payload) => client.post(`/admin/sites/${siteId}/orders/${orderId}/ship`, payload);
export const trackOrder = (siteId, orderId) => client.post(`/admin/sites/${siteId}/orders/${orderId}/track`);

// A new order: accept it (Pending moves to Confirmed) or reject it (cancelled, stock back), from the alarm or the list
export const acceptOrder = (siteId, orderId) => client.post(`/admin/sites/${siteId}/orders/${encodeURIComponent(orderId)}/accept`);
export const rejectOrder = (siteId, orderId, reason = "") => client.post(`/admin/sites/${siteId}/orders/${encodeURIComponent(orderId)}/reject`, { reason });
